// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__1gbiM","header":"styles_header__3qbcN"};